"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSummaryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var sandwich_ids_1 = require("../../../sandwich-ids");
var section_ids_1 = require("../../../section-ids");
var AccountSummaryUI_styled_1 = require("./AccountSummaryUI.styled");
var Footer = function () {
    var _a;
    var _b = (0, core_1.useComponents)(), SecondaryCTALink = _b.SecondaryCTALink, InternalLink = _b.InternalLink;
    var cardPayment = (0, core_1.useLinks)().cardPayment;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MANAGE_YOUR_PAYMENTS_LINK, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(SecondaryCTALink, { href: cardPayment(), as: InternalLink, "data-testid": "manage-your-payments-link" },
            react_1.default.createElement(Copy, { copyKey: "profile.summaryManageYourPaymentsLinkText" }))));
};
var BalanceInfo = function (_a) {
    var formattedBalance = _a.formattedBalance, debitOrCredit = _a.debitOrCredit;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Copy, { copyKey: "profile.summaryAccountBalance", values: {
            debitOrCredit: debitOrCredit,
        }, props: {
            balance: formattedBalance,
        } }));
};
var AccountSummaryUI = function (_a) {
    var _b;
    var balance = _a.balance, accountNo = _a.accountNo, latestBalanceDetails = _a.latestBalanceDetails;
    var _c = (0, core_1.useComponents)(), SummaryCard = _c.SummaryCard, Margin = _c.Margin, Pii = _c.Pii, Dd = _c.Dd, Dt = _c.Dt, Dl = _c.Dl, Strong = _c.Strong, Stack = _c.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var features = (0, core_1.useFeatureContext)().features;
    var formattedBalance = (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(balance));
    var debitOrCreditLatestBalance = balance !== '0'
        ? (latestBalanceDetails === null || latestBalanceDetails === void 0 ? void 0 : latestBalanceDetails.amount[0]) === '-'
            ? ' in debit'
            : ' in credit'
        : '';
    var debitOrCreditTotalBalance = balance !== '0' ? (balance[0] === '-' ? ' in debit' : ' in credit') : '';
    var variantTrackingName;
    switch (features === null || features === void 0 ? void 0 : features.billingComprehension) {
        case 'variant1':
            variantTrackingName = 'EnergyAccountBalanceCopy';
            break;
        case 'variant2':
            variantTrackingName = 'EnergyAccountBalancePreviousBalance';
            break;
        default:
            variantTrackingName = 'EnergyAccountBalanceCurrent';
            break;
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.ENERGY_ACCOUNT_BALANCE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b.variant = variantTrackingName, _b) },
        react_1.default.createElement(SummaryCard, { heading: react_1.default.createElement(Copy, { copyKey: "profile.summaryHeading" }), icon: "accountSummary", footer: react_1.default.createElement(Footer, null), "data-testid": section_ids_1.ACCOUNT_INFO },
            react_1.default.createElement(Dl, null,
                react_1.default.createElement(Dt, { as: AccountSummaryUI_styled_1.StyledDt, "data-testid": "account-info-balance" },
                    react_1.default.createElement(BalanceInfo, { formattedBalance: formattedBalance, debitOrCredit: debitOrCreditTotalBalance })),
                react_1.default.createElement(Dd, null,
                    react_1.default.createElement(Margin, { top: 4 },
                        react_1.default.createElement(Stack, { spaceBetween: 2 },
                            (features === null || features === void 0 ? void 0 : features.billingComprehension) === 'variant1' ? (react_1.default.createElement(Copy, { copyKey: "profile.summaryVariant1" })) : ((features === null || features === void 0 ? void 0 : features.billingComprehension) === 'variant2' &&
                                latestBalanceDetails && (react_1.default.createElement(Copy, { copyKey: "profile.summaryVariant2", values: {
                                    date: (0, date_fns_1.format)(new Date(latestBalanceDetails.endDate), 'd MMMM'),
                                    amount: (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(latestBalanceDetails.amount)),
                                    debitOrCredit: debitOrCreditLatestBalance,
                                } }))),
                            react_1.default.createElement(Copy, { copyKey: "profile.summaryUnderstandingYourBalance" })))),
                react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.accountInfoCard },
                    react_1.default.createElement(Margin, { top: 4 },
                        react_1.default.createElement(Dt, { as: AccountSummaryUI_styled_1.StyledDt },
                            react_1.default.createElement(Strong, null,
                                react_1.default.createElement(Copy, { copyKey: "profile.summaryAccountNumberLabel" }))),
                        ' ',
                        react_1.default.createElement(Dd, { as: AccountSummaryUI_styled_1.StyledDd, "data-testid": "account-number" },
                            react_1.default.createElement(Pii, null, accountNo))))))));
};
exports.AccountSummaryUI = AccountSummaryUI;
